export function handleMaxWidth(size?: string) {
  return !size ? false : window.innerWidth <= parseInt(size);
}
export function handleMinWidth(size?: string) {
  return !size ? false : window.innerWidth >= parseInt(size);
}
